import React, { useEffect, useState } from "react"
import styled from "@emotion/styled"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Navbar from "../components/navbar"
import SEO from "../components/seo"
import Layout from "../components/layout"

import icons from "../images/icons.svg"
import commonStyles from "../lib/commonStyles"
const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px;

  @media (max-width: 1100px) {
    padding: 100px 50px;
  }
`

const BgImg = styled(props => <Img {...props} />)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -100;
`

const ContactList = styled.ul`
  display: flex;
  margin-bottom: 150px;
  transform: translateY(-20px);

  @media (max-width: 820px) {
    flex-direction: column;
  }
`
const ContactItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;

  &:not(:last-child) {
    margin-right: 100px;

    @media (max-width: 880px) {
      margin-right: 75px;
    }

    @media (max-width: 820px) {
      margin-right: 0;
      margin-bottom: 60px;
    }
  }
`
const ContactIcon = styled.svg`
  fill: white;
  width: 60px;
  height: 60px;
  margin-bottom: 30px;

  @media (max-width: 1000px) {
    width: 40px;
    height: 40px;
  }

  @media (max-width: 820px) {
    width: 60px;
    height: 60px;
  }
`
const ContactTxt = styled.p`
  font-weight: 500;
  font-size: 22px;
  color: black;
  text-align: center;

  @media (max-width: 1000px) {
    font-size: 18px;
  }

  @media (max-width: 820px) {
    color: white;
    font-size: 22px;
  }
`

const ContactBox = styled.div`
  background-color: rgba(39, 154, 140, 0.6);
  padding: 50px;
  width: 1200px;

  @media (max-width: 1300px) {
    width: 90vw;
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Top = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 100%;

  @media (max-width: 880px) {
    align-items: center;
  }
`

const FirstGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 48%;

  @media (max-width: 880px) {
    margin-bottom: 20px;
    width: 70%;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 880px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`
const FormHeading = styled.h2`
  font-family: ${commonStyles.fonts.script};
  font-size: 40px;
  font-weight: 400;
  color: white;
  margin-bottom: 20px;

  @media (max-width: 880px) {
    text-align: center;
    margin-bottom: 40px;
  }
`
const FormInput = styled.input`
  margin-bottom: 20px;
  border: none;
  outline: none;
  padding: 15px 10px;
  font-family: ${commonStyles.fonts.sans};
  font-size: 20px;

  &::placeholder,
  &:-webkit-input-placeholder,
  &:-ms-input-placeholder {
    font-family: ${commonStyles.fonts.sans};
    font-size: 20px;
    color: rgb(1, 1, 1);
  }
`
const TextArea = styled.textarea`
  width: 48%;
  height: 202px;
  padding: 10px;
  font-family: ${commonStyles.fonts.sans};
  font-size: 20px;

  &::placeholder,
  &:-webkit-input-placeholder,
  &:-ms-input-placeholder {
    font-family: ${commonStyles.fonts.sans};
    font-size: 20px;
    color: rgba(1, 1, 1);
  }

  @media (max-width: 880px) {
    width: 70%;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`

const Button = styled.button`
  color: ${commonStyles.colors.darkGreen};
  font-family: ${commonStyles.fonts.script} !important;
  font-size: 40px;
  background-color: white;
  padding: 2px 22px;
  margin-bottom: 30px;
  border: none;
  border-radius: 7px;
  box-shadow: 2.2px 1.5px 0 4px darkgray;
  outline: none;
  cursor: ${props => (props.active ? "wait" : "pointer")};
`

const SuccessMsg = styled.p`
  color: white;
  text-align: center;
  font-size: 22px;
  margin: 0 auto;
  font-weight: bold;
  padding: 200px 0;
`

function Contact() {
  const data = useStaticQuery(graphql`
    query {
      bg: file(relativePath: { eq: "contact-bg.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  useEffect(() => {
    window.onRecaptchaLoadCallback = () => {
      window.recaptchaClientId = window.grecaptcha.render("inline-badge", {
        sitekey: "6LdykrcUAAAAALIocV0elJUa_15uAuv6JGaIbBX6",
        badge: "inline",
        size: "invisible",
      })
    }

    const script = document.createElement("script")

    script.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoadCallback`

    document.body.appendChild(script)
  }, [])

  const items = [
    {
      icon: "icon-phone",
      value: "5254 1655",
    },
    {
      icon: "icon-envelope-o",
      value:
        "&#104;&#101;&#108;&#108;&#111;&#064;&#104;&#111;&#108;&#105;&#100;&#097;&#121;&#098;&#105;&#114;&#100;&#115;&#046;&#110;&#101;&#116;",
    },
    {
      icon: "icon-location",
      value: "Baie Lascars,<br/> Rodrigues Island",
    },
  ].map((item, index) => {
    return (
      <ContactItem key={`contact-item-${index}`}>
        <ContactIcon>
          <use xlinkHref={`${icons}#${item.icon}`} />
        </ContactIcon>
        <ContactTxt dangerouslySetInnerHTML={{ __html: item.value }} />
      </ContactItem>
    )
  })

  const [inputName, setInputName] = useState("")
  const [inputEmail, setInputEmail] = useState("")
  const [inputPhone, setInputPhone] = useState("")
  const [textMsg, setTextMsg] = useState("")
  const [formSuccess, setFormSuccess] = useState(false)
  const [buttonState, setButtonState] = useState(false)
  async function handleSubmit(e) {
    e.preventDefault()
    setButtonState(true)

    window.grecaptcha.ready(async () => {
      const recaptchaResponse = await window.grecaptcha.execute(
        window.recaptchaClientId,
        {
          action: "contact",
        }
      )

      const postData = {
        site_name: "holidaybirds.net",
        recaptcha_response: recaptchaResponse,
        the_data: {
          name: inputName,
          email: inputEmail,
          phone: inputPhone,
          message: textMsg,
        },
      }

      const res = await fetch("https://khadk9eha8.execute-api.us-east-1.amazonaws.com/default/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "omit",
        body: JSON.stringify(postData),
      })

      if (res.status !== 200) {
        const body = await res.text()
        alert(`Failed to submit form: ${body}`)
        setButtonState(false)
      } else {
        setFormSuccess(true)
      }
    })
  }
  return (
    <>
      <SEO title="Contact us" />
      <Layout>
        <header>
          <Navbar
            fixed={false}
            hidden={false}
            variant="generic"
            page="contact"
          />
        </header>
        <Section>
          <BgImg fluid={data.bg.childImageSharp.fluid} />
          <ContactList>{items}</ContactList>
          <ContactBox>
            {formSuccess ? (
              <SuccessMsg>
                Your information has been submitted. We will contact you soon!
              </SuccessMsg>
            ) : (
              <Form onSubmit={handleSubmit}>
                <Top>
                  <FormHeading>Leave us your info</FormHeading>
                  <Container>
                    <FirstGroup>
                      <FormInput
                        value={inputName}
                        onChange={e => setInputName(e.target.value)}
                        type="text"
                        name="input-name"
                        placeholder="Name:"
                      />
                      <FormInput
                        value={inputEmail}
                        onChange={e => setInputEmail(e.target.value)}
                        type="email"
                        name="input-email"
                        placeholder="Email:"
                      />
                      <FormInput
                        value={inputPhone}
                        onChange={e => setInputPhone(e.target.value)}
                        type="tel"
                        name="input-phone"
                        placeholder="Phone:"
                      />
                    </FirstGroup>
                    <TextArea
                      value={textMsg}
                      onChange={e => setTextMsg(e.target.value)}
                      name="input-message"
                      placeholder="Additional information:"
                    />
                  </Container>
                </Top>
                <Button active={buttonState}>Submit</Button>
                <div id="inline-badge"></div>
              </Form>
            )}
          </ContactBox>
        </Section>
      </Layout>
    </>
  )
}

export default Contact
